import ImageOptimizer from '@/components/image-optimizer';
import { formatKoreanDate } from '@/lib/date';
import { convertToHyphen, slugify } from '@/lib/utils';
import { ArticleEntity, ArticleType } from '@/services/types/article.type';
import Link from 'next/link';

export default function EventCard({
  id,
  title,
  startDatetime,
  endDatetime,
  viewDatetime,
  thumbPath,
  board,
}: ArticleEntity) {
  return (
    <Link
      href={
        '/' +
        convertToHyphen(board.type.replace('_training', '')) +
        '/' +
        slugify(title, id)
      }
      className="block transition"
    >
      <div className="desktop:gap-7 flex flex-col gap-5 bg-white">
        <div className="flex gap-4">
          <div className="desktop:h-[220px] relative aspect-[27/16] w-full flex-shrink-0 overflow-hidden rounded-lg">
            <ImageOptimizer
              src={thumbPath}
              alt={title}
              fill
              className="object-cover"
              // sizes="(max-width: 768px) 100px, 120px"
            />
          </div>
        </div>
        <div className="desktop:flex desktop:h-full desktop:grow desktop:flex-col desktop:justify-between desktop:gap-4 flex flex-col gap-3">
          <div className="desktop:h-full">
            <div className="text-level-2 typo-24 desktop:typo-26 desktop:text-level-1 truncate font-extrabold">
              {title}
            </div>
          </div>
          <div className="text-level-5 typo-16 desktop:typo-18 font-semibold">
            {board?.type == ArticleType.EVENT
              ? formatKoreanDate(startDatetime) +
                ' ~ ' +
                (endDatetime ? formatKoreanDate(endDatetime) : '상시진행')
              : formatKoreanDate(viewDatetime)}
          </div>
        </div>
      </div>
    </Link>
  );
}
